import { useEffect, useState, useRef } from "react";
import styled from "styled-components";

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';
import FetchModule from "../../../../Share/Network/FetchModule";
import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';

export default function ProductSalesAddModal({ onClickExit, onSelectProduct }) {
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [products, setProducts] = useState([]);
  const ModalRef = useRef();

  useEffect(() => {
    const fetchModule = new FetchModule();
    (async () => {
      const responseData = await fetchModule.getIndividualData('product/', 'GET');
      if (responseData.status === 200) {
        setProducts(responseData.data.slice());
        setTimeout(() => {
          ModalRef.current.style.opacity = 1;
          ModalRef.current.style.transition = 'all 0.3s ease-in-out';
        }, 100);
      }
    })();
  }, []);

  return (
    <TotalModalWrapper>
      <Modal ref={ModalRef} $isDark={isDark}>
        <InnerWrapper>
          <TitleWrapper>
            <TitleTextWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text}>{t('memberDetail.productSalesModal.productSalesSelectProduct')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('memberDetail.productSalesModal.productSalesDesc')}</Text>
            </TitleTextWrapper>
            <ExitButton onClick={onClickExit}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('memberDetail.modalCancel')}</Text>
            </ExitButton>
          </TitleWrapper>
          <TotalProductView>
            <ProductViewWrapper>
              {products.map((data, index) => (
                <ProductBoxView key={index} onClick={() => onSelectProduct(data)}>
                  <ProductImageWrapper>
                    <ProductImage src={data.picture === '' ? 'https://picture.link-zone.org/DefaultLogo.png' : data.picture} />
                  </ProductImageWrapper>
                  <ProductInfoBox>
                    <ProductInfoWrapper>
                      <ProductTextWrapper alignItems='flex-start'>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} $ellipsis>{data.name}</Text>
                      </ProductTextWrapper>
                    </ProductInfoWrapper>
                    <ProductInfoWrapper>
                      <ProductTextWrapper alignItems='flex-end'>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text}>{t('memberDetail.productSalesModal.productSalesQuantity')}</Text>
                      </ProductTextWrapper>
                      <TextRowWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text}>{data.inventory.toLocaleString('ko-KR')}</Text>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text}>{t('memberDetail.productSalesModal.productSalesPieceUnit')}</Text>
                      </TextRowWrapper>
                    </ProductInfoWrapper>
                    <ProductInfoWrapper>
                      <ProductTextWrapper alignItems='flex-start'>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text}>{t('memberDetail.productSalesModal.productSalesPrice')}</Text>
                      </ProductTextWrapper>
                      <TextRowWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={16} color={theme.text}>{data.price.toLocaleString('ko-KR')}</Text>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{t('memberDetail.productSalesModal.productSalesPriceUnit')}</Text>
                      </TextRowWrapper>
                    </ProductInfoWrapper>
                  </ProductInfoBox>
                </ProductBoxView>
              ))}
              {Array.from({ length: (4 - (products.length % 4)) % 4 }).map((_, index) => (
                <PlaceholderBoxView key={'placeholder-' + index} />
              ))}
            </ProductViewWrapper>
          </TotalProductView>
        </InnerWrapper>
      </Modal>
    </TotalModalWrapper>
  );
}

const Modal = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 20px;
  opacity: 0;

  width: 872px;
  height: 592px;

  border-radius: 10px;
  background-color: ${props => props.theme.background};
`;

const InnerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 16px;

  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const TitleTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 70px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TotalProductView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 504px;

  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 4px;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.scrollBar};
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${props => props.theme.background};
    border-radius: 2px;
  }
`;

const ProductViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  flex-wrap: wrap;

  width: 100%;

  gap: 24px;
`;

const ProductBoxView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 190px;

  // box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.10);
  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const ProductImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 190px;
  height: 190px;

  overflow: hidden;

  border-radius: 10px 10px 0px 0px;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: center;
`;

const ProductInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 5px 10px;

  width: 100%;
  box-sizing: border-box;

  gap: 5px;

  border-radius: 0px 0px 10px 10px;
  background-color: ${props => props.theme.subBackground};
`;

const ProductInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 25px;
`;

const ProductTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: ${props => props.alignItems};

  width: ${props => props.width}%;
  height: 100%;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  ${props => props.$ellipsis && `
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor || 'default'};
    }
  }
`;

const TextRowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: baseline;

  gap: 2px;
`;

const PlaceholderBoxView = styled.div`
  box-sizing: border-box;

  width: 190px;
  height: 282px;

  border: 2px dashed ${props => props.theme.buttonStroke};
  border-radius: 10px;

  flex: none;
  flex-grow: 0;
`;
